(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        /* The browser tab reads "<what this page is about> - eDocuments.biz".
         *
         * MOST SPECIFIC FIRST, BRAND LAST, and that order is the whole point. A Chrome tab shows
         * roughly a dozen characters before it truncates, so with the brand in front every tab in
         * the strip reads "eDocuments.b..." and none can be told from another - worse than no scheme
         * at all, and worst exactly when many tabs are open. The favicon already carries the
         * identity visually; the title spends its characters on what the favicon cannot say.
         *
         * `subject` is a record's OWN name - a document number, an entity's name - announced by a
         * detail controller once its record resolves. It is held here rather than written straight
         * to document.title because this factory re-titles on every $translateChangeSuccess: set
         * it and forget it, and switching language would silently revert the tab from
         * "FT 2026/1612" back to the generic "Documento". */
        var BRAND = 'eDocuments.biz';
        var SEP = ' ' + String.fromCharCode(0xB7) + ' ';  // middle dot, kept out of the source bytes

        var subject = null;           // "FT 2026/1612"
        var subjectContextKey = null; // translation key for what follows it, e.g. the section

        return {
            initialize: initialize,
            updateTitle: updateTitle,
            setSubject: setSubject,
            clearSubject: clearSubject
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateLang();
                updateTitle();
            });
            updateLang();

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        /**
         * Name the record this page is about. Outranks the state's static title until the next
         * navigation clears it.
         *
         * @param text        the record's own identity, already in its final form
         * @param contextKey  optional translation key for the segment after it; the brand when omitted
         */
        function setSubject(text, contextKey) {
            subject = text || null;
            subjectContextKey = contextKey || null;
            updateTitle();
        }

        function clearSubject() {
            subject = null;
            subjectContextKey = null;
        }

        // update the window title using params in the following
        // precedence
        // 1. a record subject set by the page's own controller
        // 2. titleKey parameter
        // 3. $state.$current.data.pageTitle (current state page title)
        // 4. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }

            if (subject) {
                if (!subjectContextKey) {
                    return write(subject + SEP + BRAND);
                }
                // A record already names itself, so its section takes the second slot and the
                // brand is dropped: three segments only push the useful part out of the tab.
                return $translate(subjectContextKey).then(function (context) {
                    write(subject + SEP + context);
                }, function () {
                    // an unresolved key must not cost the tab its identity
                    write(subject + SEP + BRAND);
                });
            }

            // A section page: its name, then the brand - unless its name IS the brand, as on the
            // landing page, which would otherwise read "eDocuments.biz - eDocuments.biz".
            $translate(titleKey || 'global.title').then(function (title) {
                write(title === BRAND ? BRAND : title + SEP + BRAND);
            });
        }

        /* <html lang> is hard-coded 'pt-pt' in index.html; follow the chosen language so a screen
         * reader pronounces the English interface as English (and the browser hyphenates and
         * offers translation correctly). */
        function updateLang() {
            var lang = $translate.use() || $translate.proposedLanguage();
            if (lang) {
                $window.document.documentElement.setAttribute('lang', lang);
            }
        }

        function write(title) {
            $window.document.title = title;
        }
    }
})();
